import type { Currency } from '@sequencehq/api'
import type { Dashboardv99990101CommonModels } from '@sequencehq/api/dashboard/v99990101'

import {
  BaseCreditNoteLineItemDrawer,
  FormValues
} from 'CreditNotes/components/drawers/BaseCreditNoteLineItemDrawer'
import { DEFAULT_CREDIT_NOTE_REVENUE_RECOGNITION_METHOD } from 'CreditNotes/constants'

import { CreditNoteLineItemRow } from './CreditNoteLineItemTable'
import { submitValuesToRowFields } from './creditNoteRowForm'

type CreditNoteLineItemRateDisplay =
  Dashboardv99990101CommonModels.CreditNoteLineItems.CreditNoteLineItemRateDisplay

// A manually added line item has no referenced invoice line item, so its service
// period defaults to the invoice billing period and recognition method to the
// shared default.
const buildInitialForm = (
  defaultServicePeriod: FormValues['servicePeriod']
): FormValues => ({
  title: '',
  description: '',
  rateDisplay: 'ABSOLUTE' as CreditNoteLineItemRateDisplay,
  quantity: '1',
  amount: '',
  tax: '',
  productId: undefined,
  taxCategoryId: '',
  servicePeriod: defaultServicePeriod,
  revenueRecognitionMethod: DEFAULT_CREDIT_NOTE_REVENUE_RECOGNITION_METHOD
})

type Props = {
  isOpen: boolean
  onClose: () => void
  currency: Currency
  defaultServicePeriod: FormValues['servicePeriod']
  /** Products already used by existing rows; hidden from the product select. */
  excludedProductIds: string[]
  onAdd: (row: CreditNoteLineItemRow) => void
}

export const AddLineItem = ({
  isOpen,
  onClose,
  currency,
  defaultServicePeriod,
  excludedProductIds,
  onAdd
}: Props) => (
  <BaseCreditNoteLineItemDrawer
    isOpen={isOpen}
    onClose={onClose}
    creditNoteCurrency={currency}
    excludedProductIds={excludedProductIds}
    requireProduct
    initialValues={buildInitialForm(defaultServicePeriod)}
    title="Add line item"
    submitButtonText="Add"
    onSubmit={async values => {
      onAdd({
        rowId: crypto.randomUUID(),
        groupId: '',
        checked: true,
        ...submitValuesToRowFields(values)
      })
      return true
    }}
  />
)
